import { styled } from '@porsche-code/kado-styled-system/jsx';

export const Skeleton = styled('div', {
  base: {
    backgroundColor: 'background.surface',
    backgroundImage:
      'linear-gradient(to right, var(--colors-background-frosted) 0%, var(--colors-background-frosted-strong) 50%, var(--colors-background-frosted) 100%)',
    backgroundPosition: '0 0',
    backgroundSize: '200% 100%',
    borderRadius: 'sm',
    animation:
      'skeletonAnimation var(--durations-lg) var(--easings-base) infinite',
    height: 'md',
    width: '100%',
  },
});

export const SkeletonWrapper = styled('div', {
  base: {
    boxSizing: 'border-box',
    display: 'flex',
  },
  variants: {
    direction: {
      column: {
        flexDirection: 'column',
      },
      row: {
        flexDirection: 'row',
      },
    },
    gap: {
      sm: {
        gap: 'sm',
      },
      md: {
        gap: 'md',
      },
      lg: {
        gap: 'lg',
      },
    },
  },
  defaultVariants: {
    direction: 'row',
    gap: 'md',
  },
});
